var React = require('react');

function Ci (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#00cd00","d":"M426.8 0H640v480H426.8z","key":0}),React.createElement("path",{"fill":"#ff9a00","d":"M0 0h212.9v480H0z","key":1}),React.createElement("path",{"fill":"#fff","d":"M212.9 0h214v480h-214z","key":2})]));
}

Ci.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ci;

Ci.default = Ci;
